/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationHierarchy
 */
export interface OrganizationHierarchy {
    /**
     * 
     * @type {string}
     * @memberof OrganizationHierarchy
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationHierarchy
     */
    parent_id?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationHierarchy
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationHierarchy
     */
    tenant_name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationHierarchy
     */
    children_ids?: Array<string>;
    /**
     * The list of organizations or suborganizations that share user identities with this organization
     * @type {Array<string>}
     * @memberof OrganizationHierarchy
     */
    person_pool_orgs_ids?: Array<string>;
    /**
     * The list of organizations or suborganizations that share user groups with this organization
     * @type {Array<string>}
     * @memberof OrganizationHierarchy
     */
    group_pool_orgs_ids?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OrganizationHierarchy
     */
    manager_org_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationHierarchy
     */
    person_in_manager_org: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationHierarchy
     */
    inherits_rbac_pools: boolean;
}

/**
 * Check if a given object implements the OrganizationHierarchy interface.
 */
export function instanceOfOrganizationHierarchy(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "person_in_manager_org" in value;
    isInstance = isInstance && "inherits_rbac_pools" in value;

    return isInstance;
}

export function OrganizationHierarchyFromJSON(json: any): OrganizationHierarchy {
    return OrganizationHierarchyFromJSONTyped(json, false);
}

export function OrganizationHierarchyFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationHierarchy {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'parent_id': !exists(json, 'parent_id') ? undefined : json['parent_id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'tenant_name': !exists(json, 'tenant_name') ? undefined : json['tenant_name'],
        'children_ids': !exists(json, 'children_ids') ? undefined : json['children_ids'],
        'person_pool_orgs_ids': !exists(json, 'person_pool_orgs_ids') ? undefined : json['person_pool_orgs_ids'],
        'group_pool_orgs_ids': !exists(json, 'group_pool_orgs_ids') ? undefined : json['group_pool_orgs_ids'],
        'manager_org_id': !exists(json, 'manager_org_id') ? undefined : json['manager_org_id'],
        'person_in_manager_org': json['person_in_manager_org'],
        'inherits_rbac_pools': json['inherits_rbac_pools'],
    };
}

export function OrganizationHierarchyToJSON(value?: OrganizationHierarchy | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'parent_id': value.parent_id,
        'name': value.name,
        'tenant_name': value.tenant_name,
        'children_ids': value.children_ids,
        'person_pool_orgs_ids': value.person_pool_orgs_ids,
        'group_pool_orgs_ids': value.group_pool_orgs_ids,
        'manager_org_id': value.manager_org_id,
        'person_in_manager_org': value.person_in_manager_org,
        'inherits_rbac_pools': value.inherits_rbac_pools,
    };
}

